<div class="w-100">

    <div class="w-100 d-flex mt-2 align-items-center">


        <input type="file" name="fileSelector" [id]="customId" [(ngModel)]="fileSelected" class="inputfile"
            [accept]="fileFormatAceptStr" [multiple]="multiple" [disabled]="files.length >= maxFiles"
            (change)="handleFileInput($event)" style="display: none" />


        <label [for]="customId" class="btn btn-outline-secondary mr-3">
                <span class="icon-Subir-archivo mr-1"></span> Seleccionar <input type="file" style="display: none" />
        </label>

        <div>
            <p class="m-0 lh-18">
                Seleccione archivo<span *ngIf="multiple">s </span> a subir
            </p>
            <small class="text-secondary">{{ labelFormatAceptString }}</small>
        </div>
    </div>



    <div class="w-100 mt-2 pr-4 file-info">
        <div class="d-flex justify-content-between align-items-center" *ngFor="let file of files; let i = index">
            <i class="bi bi-file-earmark pr-1 fs-21"></i>
            <div class="d-flex flex-column flex-grow-1 mx-2 overflow-hidden">
                <div class="d-flex justify-content-between w-100">
                    <span class="file-name">{{ file.name }}</span>
                    <span class="file-size">{{ file.totalSize }} Mb</span>
                </div>

                <div class="msg-error" *ngIf="file.errorMsg">
                <!-- <div class="msg-error"> -->
                    <p class="mb-0 small text-error">{{ file.errorMsg }}</p>
                  </div>
            </div>
            <i class="ml-3 fs-16 bi bi-trash cursor-pointer" (click)="deleteFile(i)"></i>
        </div>
    </div>






</div>